export const LANDING_PAGE_NAVBAR_LINKS = [
  { title: 'Blog', href: '/blog' },
  // { title: 'Market Stats', href: '/marketstats' },
  { title: 'Contact Us', href: '/contact-us' },
];
